var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "13px",
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "89BAE1B3-783F-4C21-80CE-221F4C833260") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.64445188,-1.0658141e-14 C8.1070795,-1.0658141e-14 8.4834477,0.38065625 8.4834477,0.848554687 L8.4834477,0.848554687 L8.48251464,1.951 L11.4813525,1.95170117 C11.7625388,1.95170117 11.9904854,2.1796477 11.9904854,2.46083398 C11.9904854,2.71077735 11.8103795,2.91865473 11.5728698,2.96176399 L11.4813525,2.9699668 L10.9244435,2.9699668 L10.0921506,12.5353262 C10.0720223,12.7690102 9.897691,12.9544056 9.67593464,12.9927196 L9.59076151,13 L2.39226778,13 C2.16034589,13 1.96260096,12.8406898 1.9054936,12.6206662 L1.89087866,12.5355039 L1.05861088,2.9699668 L0.518647457,2.9699668 C0.237461169,2.9699668 0.00951464435,2.74202027 0.00951464435,2.46083398 C0.00951464435,2.21089062 0.18962054,2.00301324 0.42713019,1.95990398 L0.518647457,1.95170117 L3.51651464,1.951 L3.5165523,0.848554687 C3.5165523,0.416648437 3.83724473,0.059078726 4.25045118,0.00662365939 L4.35554812,-1.0658141e-14 Z M9.91380753,2.9699668 L2.06927197,2.9699668 L2.85323849,11.9817344 L9.12966527,11.9817344 L9.91380753,2.9699668 Z M7.44341423,4.44478125 L8.44955649,4.48210547 L8.23142259,10.5067422 L7.22528033,10.4695703 L7.44341423,4.44478125 Z M4.55641004,4.44460352 L4.77454393,10.469418 L3.76842678,10.5067422 L3.55026778,4.48195313 L4.55641004,4.44460352 Z M6.50339749,4.46344336 L6.50339749,10.4882578 L5.49660251,10.4882578 L5.49660251,4.46344336 L6.50339749,4.46344336 Z M7.47665272,1.01826562 L4.52334728,1.01826562 L4.52251464,1.951 L7.47651464,1.951 L7.47665272,1.01826562 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V0.1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "External-Users---GMS_MAZ",
    transform: "translate(-824.000000, -303.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DropDown",
    transform: "translate(810.000000, 258.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(14.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Path-2",
    fill: "#000000",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/Complementary",
    mask: "url(#mask-2)",
    fill: "#FB2525",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Complementary",
    x: 0,
    y: 0,
    width: 12,
    height: 13
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d8af8f352421ab06da2ddf12dc77022a.svg";
export { ForwardRef as ReactComponent };